import useJsonApi from "lib/useJsonApi.js";

function useSession(sessionUuid) {
  return useJsonApi({
    url: `/api/session/${sessionUuid}`,
  });
}

export default useSession;
